// Canopy Growth (Spectrum Therapeutics)
export const CANOPY_STRAINS = [
  {
    id: "canopy-snowtorious-krypton",
    name: "Snowtorious Krypton",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Krypton × Kush Mints",
    thc: 25, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Diesel", "Piżmowy", "Ziemisty"],
    description: "Działa silnie rozluźniająco na ciało, wywołując stan głębokiego fizycznego relaksu i skutecznie redukując przewlekły ból oraz stany zapalne. Początkowo może przynosić euforię i poprawy nastroju, za co odpowiedzialny jest limonen, efekt ten stopniowo przechodzi w głębokie uspokojenie i zrelaksowanie. Susz jest szczególnie ceniony w leczeniu bezsenności — ułatwia zasypianie i pomaga utrzymać ciągłość snu przez całą noc, co zawdzięcza wysokiej zawartości mircenu. Chwalony przez Pacjentów za poprawę nastroju i łagodnie usypiające działanie.",
    terpenes: { mircen: 41, limonen: 33, kariofilen: 26 },
    dominantTerpene: "Mircen", packaging: "5g"
  },
  {
    id: "canopy-bakerstreet",
    name: "Hindu Kush (Bakerstreet)",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Indica",
    lineage: "nieznany rodowód",
    thc: 20, cbd: 0.4,
    availability: "Niska", effect: "Relaksujące",
    aromas: ["Kamfora", "Lawendowy", "Mango", "Ziemisty"],
    description: "Dominujący mircen odpowiada za głęboką relaksację mięśniową, sedację i wspiera fazę głębokiego snu. Susz dodatkowo wykazuje działanie przeciwzapalne i przeciwbólowe bez nasilania efektów psychoaktywnych, a także działa przeciwlękowo i odprężająco. Pacjenci zgłaszają działanie euforyczne na początku, a potem głęboką relaksację i znaczną poprawę jakości snu.",
    terpenes: { mircen: 40.0, terpinolen: 22.0, ocymen: 12.0, pinen: 6.0 },
    dominantTerpene: "Mircen", packaging: "5g, 15g"
  },
  {
    id: "canopy-kush-mints",
    name: "Kush Mints",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "Bubba Kush × Animal Mints",
    thc: 28, cbd: 0.4,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Miętowy", "Sosnowy", "Ziemisty", "Ziołowy"],
    description: "Cztery terpeny tworzą spójny, wielokierunkowy profil: limonen działa euforyzująco i poprawia nastrój, skutecznie redukując stres, lęk i objawy depresji. Linalol wzmacnia efekt uspokajający i przeciwlękowy, a kariofilen zapewnia działanie przeciwzapalne i przeciwbólowe. Selinadien, rzadko spotykany seskwiterpen, dopełnia profil aromatyczny charakterystyczną, ziemistą nutą.",
    terpenes: { kariofilen: 32, linalol: 25, selinadien: 25, limonen: 18 },
    dominantTerpene: "Kariofilen", packaging: "5g"
  },
  {
    id: "canopy-kush-mints-30",
    name: "Kush Mints",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Hybryda",
    lineage: "Bubba Kush × Animal Mints",
    thc: 30, cbd: 0.4,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Miętowy", "Sosnowy", "Ziemisty", "Ziołowy"],
    description: "Cztery terpeny tworzą spójny, wielokierunkowy profil: limonen działa euforyzująco i poprawia nastrój, skutecznie redukując stres, lęk i objawy depresji. Linalol wzmacnia efekt uspokajający i przeciwlękowy, a kariofilen zapewnia działanie przeciwzapalne i przeciwbólowe. Selinadien, rzadko spotykany seskwiterpen, dopełnia profil aromatyczny charakterystyczną, ziemistą nutą.",
    terpenes: { kariofilen: 32, linalol: 25, selinadien: 25, limonen: 18 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "canopy-jack-haze",
    name: "Jack Haze (Red No 2)",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "White Widow × Haze",
    thc: 19, cbd: 0.5,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Kamfora", "Sosnowy"],
    description: "Charakterystyczny dla odmian o charakterze sativa terpinolen nadaje suszowi cytrusowej, energetyzującej woni i działa przeciwlękowo. Odmiana dodaje energii, poprawia nastrój i koncentrację oraz kreatywność. Skutecznie łagodzi przewlekłe zmęczenie, migreny i napięcia mięśniowe, wykazując przy tym właściwości przeciwzapalne, dzięki obecności drugiego w profilu terpenu - mircenu. W późniejszej fazie efektu przynosi delikatną relaksację bez wywoływania ciężkiej sedacji, a u wielu pacjentów wyraźnie pobudza apetyt, za co odpowiedzialne jest THC. Poza efektem stymulującym łaknienie Pacjenci zgłaszają gadatliwość i przyjemne pobudzenie, bez zbyt silnej stymulacji.",
    terpenes: { terpinolen: 41.2, mircen: 15.2, ocymen: 11.3, pinen: 5.0 },
    dominantTerpene: "Terpinolen", packaging: "5g"
  },
  {
    id: "canopy-blood-orange-kush",
    name: "Blood Orange Kush",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Lemon Kush × Guava Kush",
    thc: 29, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Korzenny", "Ziemisty"],
    description: "Blood Orange Kush to indica, z dominującym limonenem w profilu terpenowym, co stanowi bardzo ciekawe połączenie. To właśnie dominujący limonen, nie przynależność botaniczna odmiany, będzie warunkowała działanie suszu - spowoduje on aktywizację, euforię, zwiększenia kreatywności, co potwierdzają liczne opinie Pacjentów. Z czasem odczuwalna zaczyna być obecność drugiego po limonenie terpenu, mircenu i pojawia się miorelaksacja i uczucie rozluźnienia oraz wyraźne uspokojenie, które zawdzięczamy linalolowi. Oba terpeny charakteryzuje ponadto efekt analgetyczny, co czyni tę odmianę szczególnie skuteczną w terapii przewlekłego bólu i spastyczności.",
    terpenes: { limonen: 53, mircen: 27, linalol: 20 },
    dominantTerpene: "Limonen", packaging: "5g, 15g"
  },
  {
    id: "canopy-blood-orange-kush-30",
    name: "Blood Orange Kush",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Lemon Kush × Guava Kush",
    thc: 30, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Korzenny", "Ziemisty"],
    description: "Blood Orange Kush to indica, z dominującym limonenem w profilu terpenowym, co stanowi bardzo ciekawe połączenie. To właśnie dominujący limonen, nie przynależność botaniczna odmiany, będzie warunkowała działanie suszu - spowoduje on aktywizację, euforię, zwiększenia kreatywności, co potwierdzają liczne opinie Pacjentów. Z czasem odczuwalna zaczyna być obecność drugiego po limonenie terpenu, mircenu i pojawia się miorelaksacja i uczucie rozluźnienia oraz wyraźne uspokojenie, które zawdzięczamy linalolowi. Oba terpeny charakteryzuje ponadto efekt analgetyczny, co czyni tę odmianę szczególnie skuteczną w terapii przewlekłego bólu i spastyczności.",
    terpenes: { limonen: 53, mircen: 27, linalol: 20 },
    dominantTerpene: "Limonen", packaging: "5g, 15g",
    dateAdded: "2026-08-28"
  },
  {
    id: "canopy-red-velvet-cake",
    name: "Red Velvet Cake",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Red Headed Stranger × Cookies N' Cream",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Pikantny", "Słodki", "Waniliowy"],
    description: "Dominujący limonen sprawia, że lek działa pobudzająco i euforycznie — poprawia nastrój, dodaje energii i wspiera koncentrację oraz kreatywność. Wysoka zawartość THC przekłada się na skuteczne łagodzenie przewlekłego bólu, napięć mięśniowych i stresu, a obecność mircenu w suszu czyni go pomocnym w redukcji stanów lękowych. Pacjenci zgłaszają mimo charakteru sativa uczucie zrelaksowania i poprawę jakości snu.",
    terpenes: { limonen: 57, mircen: 22, kariofilen: 20 },
    dominantTerpene: "Limonen", packaging: "5g"
  },
  {
    id: "canopy-afghan-kush-25",
    name: "Afghan Kush",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Indica",
    lineage: "Hindu Kush (landrace)",
    thc: 25, cbd: 0.4,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Korzenny", "Sosnowy", "Ziemisty"],
    description: "Afghan Kush to tzw. odmiana landrace, czyli 100% indica o wysokiej zawartości THC (22,5–27,5%). W profilu terpenowym dominuje mircen powodując fizyczny relaks i odprężenie, a w wyższych dawkach sedację i poprawę jakości snu. Wraz z kariofilenem i pinenem wykazuje silnie działanie zmniejszające stan zapalny oraz łagodzące dolegliwośc bólowe, do czego przyczyna się, działając synergistycznie do pozostałych terpenów, humulen.",
    terpenes: { mircen: 25, kariofilen: 25, pinen: 25, humulen: 25 },
    dominantTerpene: "Mircen", packaging: "5g, 15g"
  },
  {
    id: "canopy-ultra-jack",
    name: "Ultra Jack",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Jack Haze × Ultra Sour",
    thc: 30, cbd: 0.4,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Korzenny", "Ziemisty"],
    description: "Odmiana z dominującym terpinolenem, typowym dla suszy o charakterze aktywizującym i energetyzującym. Mircen łagodzi nadmierne pobudzenie, które może objawiać się odczuwaniem niepokoju i dyskomfortu jako skutki uboczne terapii przy tak wysokim stężeniu THC. Dodatkowo wykazuje właściwości przeciwzapalne, synergistycznie do obecnego w leku, rzadszego terpenu - ocymenu.",
    terpenes: { terpinolen: 64, mircen: 16, ocymen: 13, farnezen: 7 },
    dominantTerpene: "Terpinolen", packaging: "5g, 15g",
    dateAdded: "2026-08-18"
  },
  {
    id: "canopy-white-widow",
    name: "White Widow",
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "White Widow × Cold Creek Kush",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Ziemisty", "Kwiatowy", "Cytrusowy"],
    description: "Dominujący w profilu terpenowym mircen będzie, wraz z wyjątkowo wysokim stężeniem THC będzie wykazywał działanie miorelaksacyjne, zmniejszając napięcie mięśniowe i przeciwzapalne, synergistycznie do limonenu. Dodatkowo limonen odpowiada za aktywizujące, pobudzające działanie odmiany i nadaje suszowi charakterystyczny świeży, energetyzujący, cytrusowy aromat.",
    terpenes: { mircen: 74, ocymen: 18, limonen: 8 },
    dominantTerpene: "Mircen", packaging: "5g, 15g",
    dateAdded: "2026-08-21"
  },
  {
    id: "canopy-chemsicle",
    name: "Chemsicle",
    dateAdded: "2026-11-01",
    isNew: true,
    producer: "Canopy Growth (Spectrum Therapeutics)",
    country: "Kanada",
    genetics: "Sativa",
    lineage: "Krypton × Chemdawg",
    thc: 27, cbd: 0.4,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Słodki", "Kremowy", "Diesel", "Ostry"],
    description: "Sativa o wysokiej zawartości THC dzięki synergii mircenu, pinenu i ocymenu działa silnie przeciwbólowo i przeciwzapalnie. Użytkownicy zgłaszają mimo energetyzującego charakteru odmiany uczucie fizycznego relaksu, które możemy wiązać z miorelaksacyjnymi właściwościami mircenu. W badaniach na zwierzętach ocymen nasilał zachowania lękowe, co w połączeniu z tak wysokim THC sprawia, że Pacjenci z historią takich dolegliwości powinni podchodzić do tego suszu z pewną dozą ostrożności.",
    terpenes: { ocymen: 33, mircen: 33, pinen: 33 },
    dominantTerpene: "Ocymen", packaging: "15g",
    dateAdded: "2026-10-28"
  }
];